var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import * as React from "react";
import React__default, { useMemo } from "react";
import { deepmerge, unstable_capitalize, internal_resolveProps, formatMuiErrorMessage, unstable_generateUtilityClass, unstable_generateUtilityClasses, unstable_composeClasses, unstable_ClassNameGenerator as unstable_ClassNameGenerator$1, unstable_createChainedFunction, unstable_debounce, unstable_deprecatedPropType, unstable_isMuiElement, unstable_ownerDocument, unstable_ownerWindow, unstable_requirePropFactory, unstable_setRef, unstable_useEnhancedEffect, unstable_useId, unstable_unsupportedProp, unstable_useControlled, unstable_useEventCallback, unstable_useForkRef, unstable_useIsFocusVisible } from "@mui/utils";
import emStyled from "@emotion/styled";
import "@emotion/react";
import { capitalize, alpha as alpha$1, lighten as lighten$1, darken as darken$1, useTheme as useTheme$3 } from "@mui/material";
import { hsluvToHex, hexToHsluv, rgbToHsluv } from "hsluv";
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d.get ? d : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  g !== void 0 && (e = "" + g);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
/** @license MUI v5.8.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(tag, options) {
  const stylesFactory = emStyled(tag, options);
  return stylesFactory;
}
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
  });
}
const values = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
};
const defaultBreakpoints = {
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getValue$1(themeMapping, transform2, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform2) {
    value = transform2(value);
  }
  return value;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform: transform2
  } = options;
  const fn = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getValue$1(themeMapping, transform2, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getValue$1(themeMapping, transform2, `${prop}${propValueFinal === "default" ? "" : unstable_capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = {};
  fn.filterProps = [prop];
  return fn;
}
function compose(...styles) {
  const handlers = styles.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = {};
  fn.filterProps = styles.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn;
}
function memoize(fn) {
  const cache = {};
  return (arg) => {
    if (cache[arg] === void 0) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split("");
  const property = properties[a];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8);
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function spacing(props) {
  return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
function getBorder(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
const border = style$1({
  prop: "border",
  themeKey: "borders",
  transform: getBorder
});
const borderTop = style$1({
  prop: "borderTop",
  themeKey: "borders",
  transform: getBorder
});
const borderRight = style$1({
  prop: "borderRight",
  themeKey: "borders",
  transform: getBorder
});
const borderBottom = style$1({
  prop: "borderBottom",
  themeKey: "borders",
  transform: getBorder
});
const borderLeft = style$1({
  prop: "borderLeft",
  themeKey: "borders",
  transform: getBorder
});
const borderColor = style$1({
  prop: "borderColor",
  themeKey: "palette"
});
const borderTopColor = style$1({
  prop: "borderTopColor",
  themeKey: "palette"
});
const borderRightColor = style$1({
  prop: "borderRightColor",
  themeKey: "palette"
});
const borderBottomColor = style$1({
  prop: "borderBottomColor",
  themeKey: "palette"
});
const borderLeftColor = style$1({
  prop: "borderLeftColor",
  themeKey: "palette"
});
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4);
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = ["borderRadius"];
const borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
var borders$1 = borders;
const displayPrint = style$1({
  prop: "displayPrint",
  cssProperty: false,
  transform: (value) => ({
    "@media print": {
      display: value
    }
  })
});
const displayRaw = style$1({
  prop: "display"
});
const overflow = style$1({
  prop: "overflow"
});
const textOverflow = style$1({
  prop: "textOverflow"
});
const visibility = style$1({
  prop: "visibility"
});
const whiteSpace = style$1({
  prop: "whiteSpace"
});
var display = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
const flexBasis = style$1({
  prop: "flexBasis"
});
const flexDirection = style$1({
  prop: "flexDirection"
});
const flexWrap = style$1({
  prop: "flexWrap"
});
const justifyContent = style$1({
  prop: "justifyContent"
});
const alignItems = style$1({
  prop: "alignItems"
});
const alignContent = style$1({
  prop: "alignContent"
});
const order = style$1({
  prop: "order"
});
const flex = style$1({
  prop: "flex"
});
const flexGrow = style$1({
  prop: "flexGrow"
});
const flexShrink = style$1({
  prop: "flexShrink"
});
const alignSelf = style$1({
  prop: "alignSelf"
});
const justifyItems = style$1({
  prop: "justifyItems"
});
const justifySelf = style$1({
  prop: "justifySelf"
});
const flexbox = compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
var flexbox$1 = flexbox;
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
});
const gridRow = style$1({
  prop: "gridRow"
});
const gridAutoFlow = style$1({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$1({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$1({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$1({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
});
const gridArea = style$1({
  prop: "gridArea"
});
const grid = compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var grid$1 = grid;
const color = style$1({
  prop: "color",
  themeKey: "palette"
});
const bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette"
});
const backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette"
});
const palette = compose(color, bgcolor, backgroundColor);
var palette$1 = palette;
const position = style$1({
  prop: "position"
});
const zIndex$2 = style$1({
  prop: "zIndex",
  themeKey: "zIndex"
});
const top = style$1({
  prop: "top"
});
const right = style$1({
  prop: "right"
});
const bottom = style$1({
  prop: "bottom"
});
const left = style$1({
  prop: "left"
});
var positions = compose(position, zIndex$2, top, right, bottom, left);
const boxShadow = style$1({
  prop: "boxShadow",
  themeKey: "shadows"
});
var shadows$2 = boxShadow;
function transform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width$1 = style$1({
  prop: "width",
  transform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || values[propValue];
      return {
        maxWidth: breakpoint || transform(propValue)
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform
});
const height$1 = style$1({
  prop: "height",
  transform
});
const maxHeight = style$1({
  prop: "maxHeight",
  transform
});
const minHeight = style$1({
  prop: "minHeight",
  transform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
const sizing = compose(width$1, maxWidth, minWidth, height$1, maxHeight, minHeight, boxSizing);
var sizing$1 = sizing;
const fontFamily = style$1({
  prop: "fontFamily",
  themeKey: "typography"
});
const fontSize = style$1({
  prop: "fontSize",
  themeKey: "typography"
});
const fontStyle = style$1({
  prop: "fontStyle",
  themeKey: "typography"
});
const fontWeight = style$1({
  prop: "fontWeight",
  themeKey: "typography"
});
const letterSpacing$1 = style$1({
  prop: "letterSpacing"
});
const textTransform = style$1({
  prop: "textTransform"
});
const lineHeight = style$1({
  prop: "lineHeight"
});
const textAlign = style$1({
  prop: "textAlign"
});
const typographyVariant = style$1({
  prop: "typography",
  cssProperty: false,
  themeKey: "typography"
});
const typography = compose(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing$1, lineHeight, textAlign, textTransform);
var typography$1 = typography;
const filterPropsMapping = {
  borders: borders$1.filterProps,
  display: display.filterProps,
  flexbox: flexbox$1.filterProps,
  grid: grid$1.filterProps,
  positions: positions.filterProps,
  palette: palette$1.filterProps,
  shadows: shadows$2.filterProps,
  sizing: sizing$1.filterProps,
  spacing: spacing.filterProps,
  typography: typography$1.filterProps
};
const styleFunctionMapping = {
  borders: borders$1,
  display,
  flexbox: flexbox$1,
  grid: grid$1,
  positions,
  palette: palette$1,
  shadows: shadows$2,
  sizing: sizing$1,
  spacing,
  typography: typography$1
};
Object.keys(filterPropsMapping).reduce((acc, styleFnName) => {
  filterPropsMapping[styleFnName].forEach((propName) => {
    acc[propName] = styleFunctionMapping[styleFnName];
  });
  return acc;
}, {});
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every((object) => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx(styleFunctionMapping$1 = styleFunctionMapping) {
  const propToStyleFunction = Object.keys(styleFunctionMapping$1).reduce((acc, styleFnName) => {
    styleFunctionMapping$1[styleFnName].filterProps.forEach((propName) => {
      acc[propName] = styleFunctionMapping$1[styleFnName];
    });
    return acc;
  }, {});
  function getThemeValue(prop, value, theme) {
    const inputProps = {
      [prop]: value,
      theme
    };
    const styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
      [prop]: value
    };
  }
  function styleFunctionSx2(props) {
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null;
    }
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (propToStyleFunction[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
var defaultStyleFunctionSx = styleFunctionSx;
function toVal(mix) {
  var k2, y, str = "";
  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      for (k2 = 0; k2 < mix.length; k2++) {
        if (mix[k2]) {
          if (y = toVal(mix[k2])) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else {
      for (k2 in mix) {
        if (mix[k2]) {
          str && (str += " ");
          str += k2;
        }
      }
    }
  }
  return str;
}
function clsx() {
  var i = 0, tmp, x, str = "";
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += " ");
        str += x;
      }
    }
  }
  return str;
}
const _excluded$8 = ["values", "unit", "step"];
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    values: values2 = {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    },
    unit = "px",
    step = 5
  } = breakpoints, other = _objectWithoutPropertiesLoose(breakpoints, _excluded$8);
  const sortedValues = sortBreakpointsValues(values2);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values2[start] === "number" ? values2[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys[endIndex]] === "number" ? values2[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
const shape = {
  borderRadius: 4
};
var shape$1 = shape;
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform2 = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing2 = (...argsInput) => {
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform2(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing2.mui = true;
  return spacing2;
}
const _excluded$7 = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded$7);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing2 = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    palette: _extends({
      mode: "light"
    }, paletteInput),
    spacing: spacing2,
    shape: _extends({}, shape$1, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  return muiTheme;
}
const ThemeContext = /* @__PURE__ */ React.createContext(null);
var ThemeContext$1 = ThemeContext;
function useTheme$2() {
  const theme = React.useContext(ThemeContext$1);
  return theme;
}
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$1(defaultTheme2 = null) {
  const contextTheme = useTheme$2();
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme2 : contextTheme;
}
const systemDefaultTheme$1 = createTheme$2();
function useTheme(defaultTheme2 = systemDefaultTheme$1) {
  return useTheme$1(defaultTheme2);
}
const _excluded$6 = ["variant"];
function isEmpty$1(string) {
  return string.length === 0;
}
function propsToClassKey(props) {
  const {
    variant
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$6);
  let classKey = variant || "";
  Object.keys(other).sort().forEach((key) => {
    if (key === "color") {
      classKey += isEmpty$1(classKey) ? props[key] : unstable_capitalize(props[key]);
    } else {
      classKey += `${isEmpty$1(classKey) ? key : unstable_capitalize(key)}${unstable_capitalize(props[key].toString())}`;
    }
  });
  return classKey;
}
const _excluded$5 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"], _excluded2 = ["theme"], _excluded3 = ["theme"];
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }
  return null;
};
const getVariantStyles = (name, theme) => {
  let variants = [];
  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }
  const variantsStyles = {};
  variants.forEach((definition) => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};
const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;
  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
  if (themeVariants) {
    themeVariants.forEach((themeVariant) => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach((key) => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });
      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }
  return variantsStyles;
};
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = createTheme$2();
function createStyled(input) {
  const {
    defaultTheme: defaultTheme2 = systemDefaultTheme,
    rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp,
    styleFunctionSx: styleFunctionSx2 = defaultStyleFunctionSx
  } = input;
  return (tag, inputOptions = {}) => {
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions, options = _objectWithoutPropertiesLoose(inputOptions, _excluded$5);
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
    const skipSx = inputSkipSx || false;
    let label;
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root") {
      shouldForwardPropOption = rootShouldForwardProp2;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp;
    }
    const defaultStyledResolver = styled$2(tag, _extends({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg) => {
        return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (_ref) => {
          let {
            theme: themeInput
          } = _ref, other = _objectWithoutPropertiesLoose(_ref, _excluded2);
          return stylesArg(_extends({
            theme: isEmpty(themeInput) ? defaultTheme2 : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = isEmpty(props.theme) ? defaultTheme2 : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);
          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle(_extends({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }
          return null;
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = isEmpty(props.theme) ? defaultTheme2 : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = isEmpty(props.theme) ? defaultTheme2 : props.theme;
          return styleFunctionSx2(_extends({}, props, {
            theme
          }));
        });
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill("");
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === "function" && styleArg.__emotion_real !== styleArg) {
        transformedStyleArg = (_ref2) => {
          let {
            theme: themeInput
          } = _ref2, other = _objectWithoutPropertiesLoose(_ref2, _excluded3);
          return styleArg(_extends({
            theme: isEmpty(themeInput) ? defaultTheme2 : themeInput
          }, other));
        };
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return internal_resolveProps(theme.components[name].defaultProps, props);
}
function useThemeProps$1({
  props,
  name,
  defaultTheme: defaultTheme2
}) {
  const theme = useTheme(defaultTheme2);
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}
function clamp(value, min = 0, max = 1) {
  return Math.min(Math.max(min, value), max);
}
function hexToRgb(color2) {
  color2 = color2.slice(1);
  const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
  let colors2 = color2.match(re);
  if (colors2 && colors2[0].length === 1) {
    colors2 = colors2.map((n2) => n2 + n2);
  }
  return colors2 ? `rgb${colors2.length === 4 ? "a" : ""}(${colors2.map((n2, index) => {
    return index < 3 ? parseInt(n2, 16) : Math.round(parseInt(n2, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function decomposeColor(color2) {
  if (color2.type) {
    return color2;
  }
  if (color2.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color2));
  }
  const marker = color2.indexOf("(");
  const type = color2.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type) === -1) {
    throw new Error(formatMuiErrorMessage(9, color2));
  }
  let values2 = color2.substring(marker + 1, color2.length - 1);
  let colorSpace;
  if (type === "color") {
    values2 = values2.split(" ");
    colorSpace = values2.shift();
    if (values2.length === 4 && values2[3].charAt(0) === "/") {
      values2[3] = values2[3].slice(1);
    }
    if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(colorSpace) === -1) {
      throw new Error(formatMuiErrorMessage(10, colorSpace));
    }
  } else {
    values2 = values2.split(",");
  }
  values2 = values2.map((value) => parseFloat(value));
  return {
    type,
    values: values2,
    colorSpace
  };
}
function recomposeColor(color2) {
  const {
    type,
    colorSpace
  } = color2;
  let {
    values: values2
  } = color2;
  if (type.indexOf("rgb") !== -1) {
    values2 = values2.map((n2, i) => i < 3 ? parseInt(n2, 10) : n2);
  } else if (type.indexOf("hsl") !== -1) {
    values2[1] = `${values2[1]}%`;
    values2[2] = `${values2[2]}%`;
  }
  if (type.indexOf("color") !== -1) {
    values2 = `${colorSpace} ${values2.join(" ")}`;
  } else {
    values2 = `${values2.join(", ")}`;
  }
  return `${type}(${values2})`;
}
function hslToRgb(color2) {
  color2 = decomposeColor(color2);
  const {
    values: values2
  } = color2;
  const h = values2[0];
  const s = values2[1] / 100;
  const l2 = values2[2] / 100;
  const a = s * Math.min(l2, 1 - l2);
  const f2 = (n2, k2 = (n2 + h / 30) % 12) => l2 - a * Math.max(Math.min(k2 - 3, 9 - k2, 1), -1);
  let type = "rgb";
  const rgb = [Math.round(f2(0) * 255), Math.round(f2(8) * 255), Math.round(f2(4) * 255)];
  if (color2.type === "hsla") {
    type += "a";
    rgb.push(values2[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
function getLuminance(color2) {
  color2 = decomposeColor(color2);
  let rgb = color2.type === "hsl" ? decomposeColor(hslToRgb(color2)).values : color2.values;
  rgb = rgb.map((val) => {
    if (color2.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color2, value) {
  color2 = decomposeColor(color2);
  value = clamp(value);
  if (color2.type === "rgb" || color2.type === "hsl") {
    color2.type += "a";
  }
  if (color2.type === "color") {
    color2.values[3] = `/${value}`;
  } else {
    color2.values[3] = value;
  }
  return recomposeColor(color2);
}
function darken(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clamp(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] *= 1 - coefficient;
  } else if (color2.type.indexOf("rgb") !== -1 || color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color2);
}
function lighten(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clamp(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] += (100 - color2.values[2]) * coefficient;
  } else if (color2.type.indexOf("rgb") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (255 - color2.values[i]) * coefficient;
    }
  } else if (color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (1 - color2.values[i]) * coefficient;
    }
  }
  return recomposeColor(color2);
}
function createMixins(breakpoints, mixins) {
  return _extends({
    toolbar: {
      minHeight: 56,
      [breakpoints.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints.up("sm")]: {
        minHeight: 64
      }
    }
  }, mixins);
}
const common = {
  black: "#000",
  white: "#fff"
};
var common$1 = common;
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
var grey$1 = grey;
const purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
};
var purple$1 = purple;
const red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
var red$1 = red;
const orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
var orange$1 = orange;
const blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
var blue$1 = blue;
const lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
};
var lightBlue$1 = lightBlue;
const green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
var green$1 = green;
const _excluded$4 = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$1.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = "light") {
  if (mode === "dark") {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }
  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(mode = "light") {
  if (mode === "dark") {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }
  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(mode = "light") {
  if (mode === "dark") {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }
  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(mode = "light") {
  if (mode === "dark") {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(mode = "light") {
  if (mode === "dark") {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }
  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(mode = "light") {
  if (mode === "dark") {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }
  return {
    main: "#ed6c02",
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(palette2) {
  const {
    mode = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette2, other = _objectWithoutPropertiesLoose(palette2, _excluded$4);
  const primary = palette2.primary || getDefaultPrimary(mode);
  const secondary = palette2.secondary || getDefaultSecondary(mode);
  const error = palette2.error || getDefaultError(mode);
  const info = palette2.info || getDefaultInfo(mode);
  const success = palette2.success || getDefaultSuccess(mode);
  const warning = palette2.warning || getDefaultWarning(mode);
  function getContrastText(background) {
    const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = _extends({}, color2);
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(formatMuiErrorMessage(11, name ? ` (${name})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(formatMuiErrorMessage(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
    }
    addLightOrDark(color2, "light", lightShade, tonalOffset);
    addLightOrDark(color2, "dark", darkShade, tonalOffset);
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  const modes = {
    dark,
    light
  };
  const paletteOutput = deepmerge(_extends({
    common: _extends({}, common$1),
    mode,
    primary: augmentColor({
      color: primary,
      name: "primary"
    }),
    secondary: augmentColor({
      color: secondary,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    error: augmentColor({
      color: error,
      name: "error"
    }),
    warning: augmentColor({
      color: warning,
      name: "warning"
    }),
    info: augmentColor({
      color: info,
      name: "info"
    }),
    success: augmentColor({
      color: success,
      name: "success"
    }),
    grey: grey$1,
    contrastThreshold,
    getContrastText,
    augmentColor,
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
const _excluded$3 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette2, typography2) {
  const _ref = typeof typography2 === "function" ? typography2(palette2) : typography2, {
    fontFamily: fontFamily2 = defaultFontFamily,
    fontSize: fontSize2 = 14,
    fontWeightLight = 300,
    fontWeightRegular: fontWeightRegular2 = 400,
    fontWeightMedium: fontWeightMedium2 = 500,
    fontWeightBold: fontWeightBold2 = 700,
    htmlFontSize = 16,
    allVariants,
    pxToRem: pxToRem2
  } = _ref, other = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  const coef = fontSize2 / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight2, size, lineHeight2, letterSpacing2, casing) => _extends({
    fontFamily: fontFamily2,
    fontWeight: fontWeight2,
    fontSize: pxToRem(size),
    lineHeight: lineHeight2
  }, fontFamily2 === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing2 / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular2, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular2, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular2, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium2, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular2, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium2, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular2, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular2, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium2, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular2, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular2, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize,
    pxToRem,
    fontFamily: fontFamily2,
    fontSize: fontSize2,
    fontWeightLight,
    fontWeightRegular: fontWeightRegular2,
    fontWeightMedium: fontWeightMedium2,
    fontWeightBold: fontWeightBold2
  }, variants), other, {
    clone: false
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;
const _excluded$2 = ["duration", "easing", "delay"];
const easing = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant = height2 / 36;
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends({}, easing, inputTransitions.easing);
  const mergedDuration = _extends({}, duration, inputTransitions.duration);
  const create = (props = ["all"], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options;
    _objectWithoutPropertiesLoose(options, _excluded$2);
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
  };
  return _extends({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;
const _excluded$1 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme$1(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded$1);
  const palette2 = createPalette(paletteInput);
  const systemTheme = createTheme$2(options);
  let muiTheme = deepmerge(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette: palette2,
    shadows: shadows$1.slice(),
    typography: createTypography(palette2, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends({}, zIndex$1)
  });
  muiTheme = deepmerge(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  return muiTheme;
}
function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
}
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length) {
  return parseFloat(length);
}
function convertLength(baseFontSize) {
  return (length, toUnit) => {
    const fromUnit = getUnit(length);
    if (fromUnit === toUnit) {
      return length;
    }
    let pxLength = toUnitless(length);
    if (fromUnit !== "px") {
      if (fromUnit === "em") {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === "rem") {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      }
    }
    let outputLength = pxLength;
    if (toUnit !== "px") {
      if (toUnit === "em") {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === "rem") {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }
    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty({
  size,
  grid: grid2
}) {
  const sizeBelow = size - size % grid2;
  const sizeAbove = sizeBelow + grid2;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function fontGrid({
  lineHeight: lineHeight2,
  pixels,
  htmlFontSize
}) {
  return pixels / (lineHeight2 * htmlFontSize);
}
function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = "rem",
  breakpoints = [600, 900, 1200],
  transform: transform2 = null
}) {
  const output = {
    [cssProperty]: `${min}${unit}`
  };
  const factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach((breakpoint) => {
    let value = min + factor * breakpoint;
    if (transform2 !== null) {
      value = transform2(value);
    }
    output[`@media (min-width:${breakpoint}px)`] = {
      [cssProperty]: `${Math.round(value * 1e4) / 1e4}${unit}`
    };
  });
  return output;
}
function responsiveFontSizes(themeInput, options = {}) {
  const {
    breakpoints = ["sm", "md", "lg"],
    disableAlign = false,
    factor = 2,
    variants = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = options;
  const theme = _extends({}, themeInput);
  theme.typography = _extends({}, theme.typography);
  const typography2 = theme.typography;
  const convert = convertLength(typography2.htmlFontSize);
  const breakpointValues = breakpoints.map((x) => theme.breakpoints.values[x]);
  variants.forEach((variant) => {
    const style2 = typography2[variant];
    const remFontSize = parseFloat(convert(style2.fontSize, "rem"));
    if (remFontSize <= 1) {
      return;
    }
    const maxFontSize = remFontSize;
    const minFontSize = 1 + (maxFontSize - 1) / factor;
    let {
      lineHeight: lineHeight2
    } = style2;
    if (!isUnitless(lineHeight2) && !disableAlign) {
      throw new Error(formatMuiErrorMessage(6));
    }
    if (!isUnitless(lineHeight2)) {
      lineHeight2 = parseFloat(convert(lineHeight2, "rem")) / parseFloat(remFontSize);
    }
    let transform2 = null;
    if (!disableAlign) {
      transform2 = (value) => alignProperty({
        size: value,
        grid: fontGrid({
          pixels: 4,
          lineHeight: lineHeight2,
          htmlFontSize: typography2.htmlFontSize
        })
      });
    }
    typography2[variant] = _extends({}, style2, responsiveProperty({
      cssProperty: "fontSize",
      min: minFontSize,
      max: maxFontSize,
      unit: "rem",
      breakpoints: breakpointValues,
      transform: transform2
    }));
  });
  return theme;
}
const defaultTheme = createTheme$1();
var defaultTheme$1 = defaultTheme;
function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme: defaultTheme$1
  });
}
const rootShouldForwardProp = (prop) => shouldForwardProp(prop) && prop !== "classes";
const styled = createStyled({
  defaultTheme: defaultTheme$1,
  rootShouldForwardProp
});
var styled$1 = styled;
var CheckCircleOutline = {};
var interopRequireDefault = { exports: {} };
(function(module) {
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireDefault);
var createSvgIcon$1 = {};
function getSvgIconUtilityClass(slot) {
  return unstable_generateUtilityClass("MuiSvgIcon", slot);
}
unstable_generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _excluded = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
const useUtilityClasses = (ownerState) => {
  const {
    color: color2,
    fontSize: fontSize2,
    classes
  } = ownerState;
  const slots = {
    root: ["root", color2 !== "inherit" && `color${unstable_capitalize(color2)}`, `fontSize${unstable_capitalize(fontSize2)}`]
  };
  return unstable_composeClasses(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = styled$1("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== "inherit" && styles[`color${unstable_capitalize(ownerState.color)}`], styles[`fontSize${unstable_capitalize(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
      duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
      medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
      large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875"
    }[ownerState.fontSize],
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
      inherit: void 0
    }[ownerState.color]
  };
});
const SvgIcon = /* @__PURE__ */ React.forwardRef(function SvgIcon2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiSvgIcon"
  });
  const {
    children,
    className,
    color: color2 = "inherit",
    component = "svg",
    fontSize: fontSize2 = "medium",
    htmlColor,
    inheritViewBox = false,
    titleAccess,
    viewBox = "0 0 24 24"
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const ownerState = _extends({}, props, {
    color: color2,
    component,
    fontSize: fontSize2,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox
  });
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses(ownerState);
  return /* @__PURE__ */ jsxRuntime.exports.jsxs(SvgIconRoot, _extends({
    as: component,
    className: clsx(classes.root, className),
    ownerState,
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? void 0 : true,
    role: titleAccess ? "img" : void 0,
    ref
  }, more, other, {
    children: [children, titleAccess ? /* @__PURE__ */ jsxRuntime.exports.jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
SvgIcon.muiName = "SvgIcon";
var SvgIcon$1 = SvgIcon;
function createSvgIcon(path, displayName) {
  const Component = (props, ref) => /* @__PURE__ */ jsxRuntime.exports.jsx(SvgIcon$1, _extends({
    "data-testid": `${displayName}Icon`,
    ref
  }, props, {
    children: path
  }));
  Component.muiName = SvgIcon$1.muiName;
  return /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(Component));
}
const unstable_ClassNameGenerator = {
  configure: (generator) => {
    console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join("\n"));
    unstable_ClassNameGenerator$1.configure(generator);
  }
};
var utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  unstable_ClassNameGenerator,
  capitalize: unstable_capitalize,
  createChainedFunction: unstable_createChainedFunction,
  createSvgIcon,
  debounce: unstable_debounce,
  deprecatedPropType: unstable_deprecatedPropType,
  isMuiElement: unstable_isMuiElement,
  ownerDocument: unstable_ownerDocument,
  ownerWindow: unstable_ownerWindow,
  requirePropFactory: unstable_requirePropFactory,
  setRef: unstable_setRef,
  unstable_useEnhancedEffect,
  unstable_useId,
  unsupportedProp: unstable_unsupportedProp,
  useControlled: unstable_useControlled,
  useEventCallback: unstable_useEventCallback,
  useForkRef: unstable_useForkRef,
  useIsFocusVisible: unstable_useIsFocusVisible
}, Symbol.toStringTag, { value: "Module" }));
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(utils);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _utils.createSvgIcon;
    }
  });
  var _utils = require$$0;
})(createSvgIcon$1);
var _interopRequireDefault$3 = interopRequireDefault.exports;
Object.defineProperty(CheckCircleOutline, "__esModule", {
  value: true
});
var default_1$3 = CheckCircleOutline.default = void 0;
var _createSvgIcon$3 = _interopRequireDefault$3(createSvgIcon$1);
var _jsxRuntime$3 = jsxRuntime.exports;
var _default$3 = (0, _createSvgIcon$3.default)(/* @__PURE__ */ (0, _jsxRuntime$3.jsx)("path", {
  d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "CheckCircleOutline");
default_1$3 = CheckCircleOutline.default = _default$3;
var InfoOutlined = {};
var _interopRequireDefault$2 = interopRequireDefault.exports;
Object.defineProperty(InfoOutlined, "__esModule", {
  value: true
});
var default_1$2 = InfoOutlined.default = void 0;
var _createSvgIcon$2 = _interopRequireDefault$2(createSvgIcon$1);
var _jsxRuntime$2 = jsxRuntime.exports;
var _default$2 = (0, _createSvgIcon$2.default)(/* @__PURE__ */ (0, _jsxRuntime$2.jsx)("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), "InfoOutlined");
default_1$2 = InfoOutlined.default = _default$2;
var WarningAmberOutlined = {};
var _interopRequireDefault$1 = interopRequireDefault.exports;
Object.defineProperty(WarningAmberOutlined, "__esModule", {
  value: true
});
var default_1$1 = WarningAmberOutlined.default = void 0;
var _createSvgIcon$1 = _interopRequireDefault$1(createSvgIcon$1);
var _jsxRuntime$1 = jsxRuntime.exports;
var _default$1 = (0, _createSvgIcon$1.default)(/* @__PURE__ */ (0, _jsxRuntime$1.jsx)("path", {
  d: "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "WarningAmberOutlined");
default_1$1 = WarningAmberOutlined.default = _default$1;
var ErrorOutline = {};
var _interopRequireDefault = interopRequireDefault.exports;
Object.defineProperty(ErrorOutline, "__esModule", {
  value: true
});
var default_1 = ErrorOutline.default = void 0;
var _createSvgIcon = _interopRequireDefault(createSvgIcon$1);
var _jsxRuntime = jsxRuntime.exports;
var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");
default_1 = ErrorOutline.default = _default;
function MuiAlert(theme) {
  return {
    defaultProps: {
      iconMapping: {
        info: /* @__PURE__ */ React__default.createElement(default_1$2, {
          color: "info",
          fontSize: "inherit"
        }),
        success: /* @__PURE__ */ React__default.createElement(default_1$3, {
          color: "success",
          fontSize: "inherit"
        }),
        warning: /* @__PURE__ */ React__default.createElement(default_1$1, {
          color: "warning",
          fontSize: "inherit"
        }),
        error: /* @__PURE__ */ React__default.createElement(default_1, {
          color: "error",
          fontSize: "inherit"
        })
      }
    },
    styleOverrides: __spreadValues({}, theme.palette.mode === "dark" ? {
      standardSuccess: {
        backgroundColor: theme.palette.success.darker,
        borderColor: "transparent"
      },
      standardInfo: {
        backgroundColor: theme.palette.info.darker,
        borderColor: "transparent"
      },
      standardWarning: {
        backgroundColor: theme.palette.warning.darker,
        borderColor: "transparent"
      },
      standardError: {
        backgroundColor: theme.palette.error.darker,
        borderColor: "transparent"
      }
    } : {
      standardSuccess: {
        borderColor: "transparent"
      },
      standardInfo: {
        borderColor: "transparent"
      },
      standardWarning: {
        borderColor: "transparent"
      },
      standardError: {
        borderColor: "transparent"
      }
    })
  };
}
function MuiAppBar(_theme) {
  return {
    defaultProps: {
      color: "inherit",
      variant: "outlined",
      elevation: 0
    }
  };
}
const containedStyles = (color2, { palette: palette2, mixins }) => ({
  color: palette2[color2].contrastText,
  backgroundColor: palette2[color2].main,
  boxShadow: "0 0 0px rgba(0,0,0,.001)",
  transition: "color 300ms ease, box-shadow 300ms ease",
  "&:hover": {
    backgroundColor: palette2.mode === "dark" ? palette2[color2].light : palette2[color2].dark
  },
  "&:focus": __spreadValues({
    backgroundColor: palette2.mode === "dark" ? palette2[color2].light : palette2[color2].dark
  }, mixins._ncr_internal.both(color2).main),
  "&:focus:hover": __spreadValues({
    backgroundColor: palette2.mode === "dark" ? palette2[color2].light : palette2[color2].dark
  }, mixins._ncr_internal.both(color2).main),
  "&.Mui-focusVisible": __spreadValues({
    backgroundColor: palette2.mode === "dark" ? palette2[color2].light : palette2[color2].dark
  }, mixins._ncr_internal.groupContained(color2).focusVisible),
  "&.MuiButtonGroup-groupedContained:focus": __spreadValues({}, mixins._ncr_internal.both(color2).main),
  "&.MuiButtonGroup-groupedContained:hover": __spreadValues({}, mixins._ncr_internal.both(color2).main),
  "&.MuiButtonGroup-groupedContained:focus:hover": __spreadValues({}, mixins._ncr_internal.both(color2).main),
  "&.MuiButtonGroup-groupedContained.Mui-focusVisible": __spreadValues({
    backgroundColor: palette2.mode === "dark" ? palette2[color2].light : palette2[color2].dark
  }, mixins._ncr_internal.groupContained(color2).focusVisible)
});
const Contained = (theme) => colors.map((name) => ({
  props: { variant: "contained", color: name },
  style: containedStyles(name, theme)
}));
function ifLight(ifLightColor, elseColor, theme) {
  if (theme.palette.mode === "light") {
    return ifLightColor(theme.palette);
  } else {
    return elseColor(theme.palette);
  }
}
const outlinedStyles = (color2, theme) => {
  const { palette: palette2, mixins } = theme;
  return {
    borderStyle: "solid",
    borderWidth: "1px",
    boxShadow: "0 0 0px rgba(0,0,0,.001)",
    transition: "color 300ms ease, border-color 300ms ease, box-shadow 300ms ease",
    "&:hover": {
      color: ifLight((t) => t[color2].dark, (t) => t[color2].light, theme)
    },
    "&:focus": __spreadValues({}, mixins._ncr_internal.bothOutline(color2).main),
    "&:focus:hover": __spreadValues({}, mixins._ncr_internal.bothOutline(color2).main),
    "&.Mui-focusVisible": __spreadValues({}, mixins._ncr_internal.bothOutline(color2).focusVisible),
    "&.MuiButtonGroup-groupedOutlined:focus": __spreadValues({}, mixins._ncr_internal.groupOutline(color2)),
    "&.MuiButtonGroup-groupedOutlined:hover": __spreadValues({}, mixins._ncr_internal.groupOutline(color2)),
    "&.MuiButtonGroup-groupedOutlined:focus:hover": __spreadValues({}, mixins._ncr_internal.groupOutline(color2)),
    "&.MuiButtonGroup-groupedOutlined.Mui-focusVisible": __spreadValues({}, mixins._ncr_internal.groupOutline(color2, true)),
    "&.MuiButtonGroup-groupedOutlinedHorizontal:not(:last-child):focus + .MuiButtonGroup-groupedOutlinedHorizontal.MuiButtonGroup-groupedOutlinedHorizontal.MuiButton-outlined": {
      borderLeftColor: palette2[color2].main
    },
    "&.MuiButtonGroup-groupedOutlinedHorizontal:not(:last-child):hover + .MuiButtonGroup-groupedOutlinedHorizontal.MuiButtonGroup-groupedOutlinedHorizontal.MuiButton-outlined": {
      borderLeftColor: palette2[color2].main
    },
    "&.MuiButtonGroup-groupedOutlinedVertical:not(:last-child):focus + .MuiButtonGroup-groupedOutlinedVertical.MuiButtonGroup-groupedOutlinedVertical.MuiButton-outlined": {
      borderTopColor: palette2[color2].main
    },
    "&.MuiButtonGroup-groupedOutlinedVertical:not(:last-child):hover + .MuiButtonGroup-groupedOutlinedVertical.MuiButtonGroup-groupedOutlinedVertical.MuiButton-outlined": {
      borderTopColor: palette2[color2].main
    }
  };
};
const outlined = (theme) => colors.map((name) => ({
  props: { variant: "outlined", color: name },
  style: outlinedStyles(name, theme)
}));
const textStyles = (color2, theme) => {
  const { mixins } = theme;
  return {
    boxShadow: "0 0 0px rgba(0,0,0,.001)",
    transition: "color 300ms ease, box-shadow 300ms ease",
    "&:hover": {
      color: ifLight((t) => t[color2].dark, (t) => t[color2].light, theme)
    },
    "&:focus": {
      color: ifLight((t) => t[color2].dark, (t) => t[color2].light, theme)
    },
    "&:focus:hover": {
      color: ifLight((t) => t[color2].dark, (t) => t[color2].light, theme)
    },
    "&.Mui-focusVisible": __spreadValues({
      color: ifLight((t) => t[color2].dark, (t) => t[color2].light, theme)
    }, mixins._ncr_internal.bothOutline(color2).focusVisible),
    "&.MuiButtonGroup-groupedText:focus": __spreadValues({}, mixins._ncr_internal.groupText(color2)),
    "&.MuiButtonGroup-groupedText:hover": __spreadValues({}, mixins._ncr_internal.groupText(color2)),
    "&.MuiButtonGroup-groupedText:focus:hover": __spreadValues({}, mixins._ncr_internal.groupText(color2)),
    "&.MuiButtonGroup-groupedText.Mui-focusVisible": __spreadValues({}, mixins._ncr_internal.groupText(color2, true))
  };
};
const text = (theme) => colors.map((name) => ({
  props: { variant: "text", color: name },
  style: textStyles(name, theme)
}));
const colors = [
  "primary",
  "secondary",
  "error",
  "info",
  "success",
  "warning"
];
function MuiButton(theme) {
  return {
    defaultProps: {
      disableElevation: true,
      disableFocusRipple: true,
      disableRipple: true,
      disableTouchRipple: true
    },
    variants: [...Contained(theme), ...outlined(theme), ...text(theme)]
  };
}
function MuiButtonBase(theme) {
  return {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true
    },
    styleOverrides: {
      root: {
        "&.Mui-focusVisible": {
          boxShadow: `0px 0px 1px ${theme.palette.grey["300"]}`
        }
      }
    }
  };
}
function MuiButtonGroup(_theme) {
  return {
    defaultProps: {
      disableElevation: true,
      disableFocusRipple: true,
      disableRipple: true
    }
  };
}
function MuiCard(_theme) {
  return {
    defaultProps: {
      elevation: 0,
      variant: "outlined"
    }
  };
}
const createIcon = (Path, componentName) => (props) => {
  const sizeName = props.fontSize || "normal";
  const size = sizeName === "small" ? ["16px", { margin: "2px" }] : ["18px", { margin: "1px" }];
  return /* @__PURE__ */ React.createElement("span", {
    className: `ncr${capitalize(componentName)}-size${capitalize(sizeName)} ncr${capitalize(componentName)}-wrapper`,
    style: __spreadValues({ display: "inline-flex" }, size[1])
  }, /* @__PURE__ */ React.createElement("svg", __spreadProps(__spreadValues({
    width: size[0],
    height: size[0],
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), {
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */ React.createElement(Path, null)));
};
const CheckboxEmpty = () => /* @__PURE__ */ React.createElement(React.Fragment, null);
const CheckboxIndeterminate = () => /* @__PURE__ */ React.createElement("path", {
  d: "M5.33331 11.1875C4.88458 11.1875 4.52081 11.5513 4.52081 12C4.52081 12.4487 4.88458 12.8125 5.33331 12.8125V11.1875ZM18.6666 12.8125C19.1154 12.8125 19.4791 12.4487 19.4791 12C19.4791 11.5513 19.1154 11.1875 18.6666 11.1875V12.8125ZM5.33331 12.8125H18.6666V11.1875H5.33331V12.8125Z",
  fill: "currentColor"
});
const CheckboxChecked = () => /* @__PURE__ */ React.createElement("path", {
  d: "M5.33331 13.2911L9.43014 17.3882L18.6666 6.61178",
  stroke: "currentColor",
  strokeWidth: "1.625",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const CheckboxIcon = {
  Checked: createIcon(CheckboxChecked, "checkbox"),
  Empty: createIcon(CheckboxEmpty, "checkbox"),
  Indeterminate: createIcon(CheckboxIndeterminate, "checkbox")
};
const RadioEmpty = () => /* @__PURE__ */ React.createElement(React.Fragment, null);
const RadioChecked = () => /* @__PURE__ */ React.createElement("path", {
  d: "M5.33331 13.2911L9.43014 17.3882L18.6666 6.61178",
  stroke: "currentColor",
  strokeWidth: "1.625",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const RadioIcon = {
  Checked: createIcon(RadioChecked, "radio"),
  Empty: createIcon(RadioEmpty, "radio")
};
function MuiCheckbox(theme) {
  const { palette: palette2 } = theme;
  return {
    defaultProps: {
      disableFocusRipple: true,
      disableRipple: true,
      disableTouchRipple: true,
      icon: /* @__PURE__ */ React__default.createElement(CheckboxIcon.Empty, null),
      checkedIcon: /* @__PURE__ */ React__default.createElement(CheckboxIcon.Checked, null),
      indeterminateIcon: /* @__PURE__ */ React__default.createElement(CheckboxIcon.Indeterminate, null)
    },
    styleOverrides: {
      root: {
        color: palette2.grey["600"],
        "&:hover": {
          color: palette2.grey["700"]
        },
        "& .ncrCheckbox-wrapper": {
          borderRadius: 4,
          borderWidth: 2,
          borderColor: palette2.grey["400"],
          borderStyle: "solid",
          backgroundColor: "transparent",
          willChange: "border-color, background-color",
          userSelect: "none",
          contain: "layout paint"
        },
        "&.MuiIconButton-root.Mui-focusVisible": {
          backgroundColor: "transparent"
        },
        "&.Mui-focusVisible .ncrCheckbox-wrapper": {
          boxShadow: `0px 0px 0px 4px ${palette2.grey[300]}`,
          borderColor: palette2.grey[500],
          color: palette2.grey[500]
        },
        "& .ncrCheckbox-wrapper svg": {
          color: palette2.primary.contrastText
        },
        "&.Mui-checked": {
          "&:not(.Mui-disabled) .ncrCheckbox-wrapper": {
            borderColor: "currentcolor",
            borderStyle: "solid",
            backgroundColor: "currentcolor"
          }
        },
        "&.Mui-disabled .ncrCheckbox-wrapper": {
          backgroundColor: palette2.grey["700"],
          borderColor: palette2.grey["700"],
          opacity: 0.3
        }
      },
      colorPrimary: {
        color: palette2.primary.main,
        transition: "color 300ms ease",
        "&:hover": {
          color: ifLight((t) => t.primary.dark, (t) => t.primary.light, theme)
        },
        "&.Mui-focusVisible .ncrCheckbox-wrapper": {
          boxShadow: `0px 0px 0px 4px ${alpha$1(palette2.primary.light, 0.5)}`,
          borderColor: palette2.primary.main,
          color: palette2.primary.main
        }
      },
      colorSecondary: {
        color: palette2.secondary.main,
        transition: "color 300ms ease",
        "&:hover": {
          backgroundColor: "transparent",
          color: ifLight((t) => t.secondary.dark, (t) => t.secondary.light, theme)
        },
        "&.Mui-focusVisible .ncrCheckbox-wrapper": {
          boxShadow: `0px 0px 0px 4px ${alpha$1(palette2.secondary.light, 0.5)}`,
          borderColor: palette2.secondary.main,
          color: palette2.secondary.main
        }
      },
      indeterminate: {
        "&:not(.Mui-disabled) .ncrCheckbox-wrapper": {
          borderColor: "currentcolor",
          borderStyle: "solid",
          backgroundColor: "currentcolor"
        }
      }
    }
  };
}
const toHex = (color2) => {
  if (color2.startsWith("#")) {
    return color2;
  } else if (color2.startsWith("rgb")) {
    const rgb = color2.replace(/[^\d\.\,]/g, "").split(",").map((x) => parseInt(x));
    const luv = rgbToHsluv([rgb[0], rgb[1], rgb[2]]);
    return hsluvToHex(luv);
  } else if (color2.startsWith("hsl")) {
    const hsl = color2.replace(/[^\d\.\,]/g, "").split(",").map((x) => parseInt(x));
    return hsluvToHex([hsl[0], hsl[1], hsl[2]]);
  } else {
    return color2;
  }
};
const setLuminance = (color2, targetLum) => {
  const hsColor = hexToHsluv(color2);
  return hsluvToHex([hsColor[0], hsColor[1], targetLum]);
};
const minLuminance = (color2, contrastRatio) => {
  const hsl = hexToHsluv(color2);
  const targetLum = contrastRatio * (hsl[2] + 0.05) - 0.05;
  return targetLum;
};
const maxLuminance = (color2, contrastRatio) => {
  const hsl = hexToHsluv(color2);
  const targetLum = (hsl[2] + 0.05) / contrastRatio - 0.05;
  return targetLum;
};
const alterLuminance = (hex, amt) => {
  const r = hexToHsluv(hex);
  r[2] += amt;
  return hsluvToHex(r);
};
function MuiChip(theme) {
  var _a;
  const { palette: palette2 } = theme;
  const { mode } = palette2;
  const p2 = (color2) => palette2[color2];
  const tonalOffset = typeof palette2.tonalOffset == "number" ? palette2.tonalOffset : (_a = palette2.tonalOffset[mode]) != null ? _a : 0.1;
  return {
    styleOverrides: {
      sizeSmall: ({}) => {
        return {
          height: "26px"
        };
      },
      deleteIcon: ({ ownerState: { color: token } }) => {
        var _a2, _b;
        token = token === "default" ? "primary" : token;
        const color2 = mode === "light" ? (_a2 = p2(token)) == null ? void 0 : _a2.darker : (_b = p2(token)) == null ? void 0 : _b.lighter;
        const hoverColor = mode === "light" ? lighten$1(color2, tonalOffset) : darken$1(color2, tonalOffset);
        return {
          color: color2,
          "&:hover": { color: hoverColor },
          "&:active": { color: hoverColor }
        };
      },
      avatar: ({ ownerState: { color: c, size } }) => {
        var _a2, _b, _c, _d;
        const color2 = c === "default" ? "primary" : c;
        return __spreadValues({
          color: mode === "light" ? (_a2 = p2(color2)) == null ? void 0 : _a2.contrastText : (_b = p2(color2)) == null ? void 0 : _b.contrastText,
          backgroundColor: mode === "light" ? (_c = p2(color2)) == null ? void 0 : _c.main : (_d = p2(color2)) == null ? void 0 : _d.main
        }, size === "small" ? { marginLeft: "4px" } : {});
      },
      label: ({ ownerState: { color: color2, size } }) => {
        var _a2, _b;
        return {
          color: mode === "light" ? (_a2 = p2(color2)) == null ? void 0 : _a2.darker : (_b = p2(color2)) == null ? void 0 : _b.lighter,
          fontWeight: 500,
          margin: size === "medium" ? "3px 1px" : void 0
        };
      },
      root: ({ ownerState: { variant, color: color2 } }) => {
        var _a2, _b, _c, _d, _e, _f, _g, _h;
        return variant === "filled" && color2 !== "default" ? {
          background: mode === "light" ? (_a2 = p2(color2)) == null ? void 0 : _a2.lighter : (_b = p2(color2)) == null ? void 0 : _b.darker,
          color: mode === "light" ? (_c = p2(color2)) == null ? void 0 : _c.darker : (_d = p2(color2)) == null ? void 0 : _d.lighter,
          "&:hover": {
            background: mode === "light" ? (_e = p2(color2)) == null ? void 0 : _e.lighter : (_f = p2(color2)) == null ? void 0 : _f.darker
          },
          ".MuiChip-clickable&:hover": {
            background: mode === "light" ? alterLuminance(p2(color2).lighter, -5) : alterLuminance((_g = p2(color2)) == null ? void 0 : _g.dark, 0.1)
          },
          "&.Mui-focusVisible": {
            background: mode === "light" ? alterLuminance(p2(color2).lighter, -5) : alterLuminance((_h = p2(color2)) == null ? void 0 : _h.dark, 1)
          }
        } : {};
      }
    }
  };
}
function MuiDataGrid(_theme) {
  return {
    defaultProps: {},
    styleOverrides: {
      columnHeader: {
        "&:not(:hover) .MuiDataGrid-menuIcon": {
          visibility: "visible",
          border: "0 !important",
          clip: "rect(1px, 1px, 1px, 1px) !important",
          clipPath: "inset(50%) !important",
          height: "1px !important",
          margin: "-1px !important",
          overflow: "hidden !important",
          padding: "0 !important",
          position: "absolute !important",
          width: "1px !important",
          whiteSpace: "nowrap !important"
        }
      },
      "columnHeader--sortable": {
        '&:not(:hover):not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-columnHeaderTitleContainer .MuiButtonBase-root[title="Sort"]': {
          visibility: "visible",
          border: "0 !important",
          clip: "rect(1px, 1px, 1px, 1px) !important",
          clipPath: "inset(50%) !important",
          height: "1px !important",
          margin: "-1px !important",
          overflow: "hidden !important",
          padding: "0 !important",
          position: "absolute !important",
          width: "1px !important",
          whiteSpace: "nowrap !important"
        }
      }
    }
  };
}
function MuiFilledInput(theme) {
  return {
    defaultProps: {
      disableUnderline: true
    },
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "transparent",
        boxShadow: `0px 0px 0px 1px ${ifLight((t) => t.grey[400], (t) => t.grey["800"], theme)}`,
        borderStyle: "solid",
        borderWidth: 0,
        "&.MuiInputBase-root": {
          backgroundColor: "transparent"
        },
        "&:hover:not(.Mui-disabled)": {
          boxShadow: `0px 0px 0px 1px ${theme.palette.text.primary}`
        },
        "&.Mui-error, &.MuiInputBase-colorSecondary.Mui-error": {
          boxShadow: `0px 0px 0px 1px ${theme.palette.error.main}`,
          "&.Mui-focused, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: `0px 0px 0px 2px ${theme.palette.error.main}`
          }
        },
        "&.Mui-focused, &.Mui-active, &.Mui-focusVisible": {
          boxShadow: `0px 0px 0px 2px ${theme.palette.primary.main}`,
          "&.MuiInputBase-colorSecondary": {
            boxShadow: `0px 0px 0px 2px ${theme.palette.secondary.main}`
          }
        }
      },
      focused: {
        borderWidth: 2,
        backgroundColor: "transparent"
      },
      input: {
        backgroundColor: "transparent",
        borderRadius: "inherit",
        "&.Mui-focused, &.Mui-focusVisible, &.Mui-active": {
          backgroundColor: "transparent !important"
        }
      }
    }
  };
}
function MuiIconButton(_) {
  return {
    defaultProps: {
      focusRipple: false
    }
  };
}
function MuiInputLabel(_theme) {
  return {
    styleOverrides: {
      filled: {
        "&:not(.MuiInputLabel-shrink):not(.MuiInputLabel-sizeSmall)": {
          transform: "translate(12px, 18px) scale(1)"
        }
      }
    }
  };
}
function MuiLinearProgress(theme) {
  const { palette: palette2 } = theme;
  const p2 = (color2) => palette2[color2];
  const makeBgColor = ({ color: color2 }) => {
    var _a, _b;
    return palette2.mode === "light" ? color2 === "warning" ? lighten$1(palette2.warning.light, 0.75) : lighten$1((_a = p2(color2)) == null ? void 0 : _a[palette2.mode === "light" ? "light" : "dark"], 0.7) : color2 === "warning" ? darken$1(palette2.warning.dark, 0.4) : darken$1((_b = p2(color2)) == null ? void 0 : _b.dark, 0.4);
  };
  return {
    styleOverrides: {
      bar: ({ ownerState: { color: color2 } }) => __spreadValues({}, color2 === "warning" ? {
        backgroundColor: palette2.mode === "light" ? palette2.warning.dark : palette2.warning.main
      } : {}),
      bar2Buffer: ({ ownerState: { color: color2 } }) => ({
        backgroundColor: makeBgColor({ color: color2 })
      }),
      root: ({ ownerState: { color: color2, variant } }) => ({
        borderRadius: "4px",
        backgroundColor: variant === "buffer" ? "transparent" : makeBgColor({ color: color2 })
      })
    }
  };
}
function MuiPaper(_theme) {
  return {
    defaultProps: {
      variant: "outlined",
      elevation: 0
    }
  };
}
function MuiRadio(theme) {
  const { palette: palette2 } = theme;
  return {
    defaultProps: {
      icon: /* @__PURE__ */ React__default.createElement(RadioIcon.Empty, null),
      checkedIcon: /* @__PURE__ */ React__default.createElement(RadioIcon.Checked, null)
    },
    styleOverrides: {
      root: {
        color: palette2.grey[500],
        "& .ncrRadio-wrapper": {
          borderRadius: "500px",
          borderWidth: 2,
          borderColor: palette2.grey[400],
          borderStyle: "solid",
          backgroundColor: "transparent",
          transition: "background-color 300ms ease",
          userSelect: "none",
          contain: "layout paint"
        },
        "&.Mui-focusVisible": {
          boxShadow: "none"
        },
        "&.Mui-checked": {
          "& .ncrRadio-wrapper": {
            background: "currentcolor",
            borderColor: "currentcolor"
          }
        },
        "&.Mui-disabled": {
          color: palette2.grey[400],
          "& .ncrRadio-wrapper": {
            opacity: 0.3
          }
        },
        "&:hover": {
          background: "none"
        }
      },
      colorPrimary: {
        color: palette2.primary.main,
        "& .ncrRadio-wrapper svg": {
          color: palette2.primary.contrastText
        },
        "&:hover, &.Mui-checked:hover": {
          backgroundColor: "transparent",
          color: ifLight((t) => t.primary.dark, (t) => t.primary.light, theme)
        },
        "&.Mui-focusVisible .ncrRadio-wrapper": {
          borderColor: palette2.primary.dark,
          boxShadow: `0px 0px 0px 4px ${alpha$1(palette2.primary.light, 0.5)}`
        }
      },
      colorSecondary: {
        color: palette2.secondary.main,
        "& .ncrRadio-wrapper svg": {
          color: palette2.secondary.contrastText
        },
        "&:hover, &.Mui-checked:hover": {
          backgroundColor: "transparent",
          color: ifLight((t) => t.secondary.dark, (t) => t.secondary.light, theme)
        },
        "&.Mui-focusVisible .ncrRadio-wrapper": {
          borderColor: palette2.secondary.dark,
          boxShadow: `0px 0px 0px 4px ${alpha$1(palette2.secondary.light, 0.5)}`
        }
      }
    }
  };
}
function MuiSlider({ palette: palette2 }) {
  return {
    styleOverrides: {
      thumb: {
        height: 22,
        width: 22,
        marginTop: 0,
        marginLeft: 0,
        "&:not(.MuiSlider-thumbSizeSmall)": {
          backgroundColor: "#fff",
          boxShadow: `0px 4px 8px 0px rgba(0, 0, 0, 0.15), inset 0 0 1px 1px ${palette2.grey["300"]}`
        }
      },
      track: {
        border: "none"
      },
      thumbSizeSmall: {
        height: 12,
        width: 12,
        boxShadow: "none",
        transformOrigin: "center",
        transition: "transform 150ms",
        "&:hover, &.Mui-active, &.Mui-focusVisible": {
          boxShadow: "none"
        },
        "&:hover, &.Mui-active": {
          transform: "scale(150%) translateY(-35%) translateX(-35%)",
          "& > .MuiSlider-valueLabelOpen": {
            transform: "scale(75%) translateY(-110%)"
          }
        }
      }
    }
  };
}
const height = 26;
const width = 44;
const outline = 3;
const heightSmall = 16;
const widthSmall = 28;
const outlineSmall = 2;
function MuiSwitch({ palette: palette2 }) {
  return {
    defaultProps: {
      focusRipple: false
    },
    styleOverrides: {
      root: ({ ownerState: colorPrimary }) => {
        return {
          width,
          height,
          padding: 0,
          margin: 8,
          contain: "strict",
          color: palette2.mode === "light" ? palette2.grey[400] : palette2.grey[800],
          "&:hover": {
            filter: `drop-shadow(0px 0px 4px ${colorPrimary.color === "primary" ? alpha$1(palette2.primary.main, 0.9) : alpha$1(palette2.secondary.main, 0.9)})`
          }
        };
      },
      switchBase: {
        padding: outline,
        "&.Mui-checked": {
          transform: `translateX(${width - height}px)`,
          "& + &.MuiSwitch-track": {
            backgroundColor: "currentColor",
            opacity: 1,
            border: "none"
          }
        },
        "&.Mui-disabled": {
          border: "none",
          backgroundColor: "none",
          opacity: 0.4,
          "&.Mui-checked": {
            opacity: 0.4
          },
          "&.Mui-checked + .MuiSwitch-track, & + .MuiSwitch-track": {
            opacity: 0.2,
            border: "none"
          },
          "& .MuiSwitch-thumb": {
            boxShadow: "none"
          }
        },
        "&.Mui-focusVisible": {
          "& .MuiSwitch-thumb": {
            boxShadow: "none"
          },
          "& + .MuiSwitch-track": {
            boxShadow: `inset 0px 0px 0px 1px ${palette2.grey["400"]}, inset 0px 0px 0px 3px ${palette2.primary.contrastText}`
          }
        },
        "&.Mui-focusVisible.Mui-checked": {
          "&.MuiSwitch-colorPrimary": {
            "& + .MuiSwitch-track": {
              boxShadow: `inset 0px 0px 0px 1px ${palette2.primary.main}, inset 0px 0px 0px 3px ${palette2.primary.contrastText}`
            }
          },
          "&.MuiSwitch-colorSecondary": {
            "& + .MuiSwitch-track": {
              boxShadow: `inset 0px 0px 0px 1px ${palette2.secondary.main}, inset 0px 0px 0px 3px ${palette2.secondary.contrastText}`
            }
          }
        }
      },
      thumb: {
        width: height - outline * 2,
        height: height - outline * 2,
        backgroundColor: "white",
        border: `inset 2px solid ${palette2.grey["400"]}`
      },
      track: {
        borderRadius: height / 2,
        backgroundColor: "currentColor",
        opacity: 1,
        transition: "background-color 200ms ease, border 200ms ease",
        willChange: "background-color, border, box-shadow"
      },
      colorPrimary: {
        "&.Mui-checked + .MuiSwitch-track": {
          color: palette2.primary.main,
          opacity: 1
        }
      },
      colorSecondary: {
        "&.Mui-checked + .MuiSwitch-track": {
          color: palette2.secondary.main,
          opacity: 1
        }
      },
      input: {
        backgroundColor: "transparent"
      },
      sizeSmall: {
        height: heightSmall,
        width: widthSmall,
        "& .MuiSwitch-switchBase": {
          padding: outlineSmall * 2,
          margin: -1 * outlineSmall,
          "&:hover": {
            backgroundColor: "transparent"
          },
          "&.Mui-checked": {
            transform: `translateX(${widthSmall - heightSmall}px)`
          }
        },
        "& .MuiSwitch-thumb": {
          width: heightSmall - outlineSmall * 2,
          height: heightSmall - outlineSmall * 2
        },
        "& .MuiSwitch-track": {
          borderRadius: heightSmall / 2
        }
      }
    }
  };
}
function MuiTextField(_theme) {
  return {
    defaultProps: {
      variant: "filled"
    }
  };
}
function MuiFormHelperText(_theme) {
  return {
    defaultProps: {
      component: "div"
    }
  };
}
function makeInternalMixins({ palette: palette2 }) {
  const makeC = (props) => ({
    300: props === "grey" ? palette2.grey["300"] : alpha(palette2[props].light, 0.2),
    400: props === "grey" ? palette2.grey["400"] : palette2[props].light,
    600: props === "grey" ? palette2.grey["600"] : palette2[props].dark,
    contrastText: props === "grey" ? palette2.grey["50"] : palette2[props].contrastText,
    800: props === "grey" ? palette2.grey["800"] : darken(palette2[props].dark, 0.3)
  });
  const hlbothContained = (props) => {
    const c = makeC(props);
    return {
      main: {
        boxShadow: `0px 0px 4px ${c["400"]}, 0px 0px 6px ${c["400"]}`
      },
      focusVisible: {
        boxShadow: `inset 0px 0px 0px 2px ${c["600"]}, inset 0px 0px 0px 4px ${c.contrastText}`
      }
    };
  };
  const hlbothOutline = (props) => {
    const c = makeC(props);
    return {
      main: {
        boxShadow: `0px 0px 4px 0px ${c["300"]}, 0px 0px 6px ${c["400"]}`
      },
      focusVisible: {
        boxShadow: `inset 0px 0px 0px 2px ${c["400"]}`
      }
    };
  };
  const hlboth = (props) => {
    const c = makeC(props);
    return {
      main: {
        boxShadow: `0px 0px 4px 0px ${c["300"]}, 0px 0px 6px ${c["400"]}`
      },
      focusVisible: {
        boxShadow: `inset 0px 0px 0px 2px ${c["800"]}`
      }
    };
  };
  const hlgroupContained = (props, fv = false) => {
    const c = makeC(props);
    return {
      main: {
        boxShadow: `inset 0px 0px 0px ${fv ? "2" : "1"}px ${c["600"]}`
      },
      focusVisible: {
        boxShadow: `inset 0px 0px 0px 2px ${c["600"]}, inset 0px 0px 0px 4px ${c.contrastText}`
      }
    };
  };
  const hlgroupOutline = (props, fv = false) => {
    const c = makeC(props);
    return {
      boxShadow: `inset 0px 0px 0px ${fv ? "2" : "0"}px ${c["400"]}`
    };
  };
  const hlgroupText = (props, fv = false) => {
    const c = makeC(props);
    return {
      boxShadow: `inset 0px 0px 0px ${fv ? "2" : "0"}px ${palette2.mode === "dark" ? c["800"] : c["300"]}`
    };
  };
  return {
    bothContained: hlbothContained,
    bothOutline: hlbothOutline,
    both: hlboth,
    groupContained: hlgroupContained,
    groupOutline: hlgroupOutline,
    groupText: hlgroupText
  };
}
const letterSpacing = (fontSize2) => {
  const a = -0.0223, b = 0.185, c = -0.1745, z = fontSize2;
  return `${(a + b * Math.exp(c * z)).toFixed(4)}em`;
};
const createMuiDefault = (props) => {
  if (props.letterSpacing) {
    return props;
  }
  return __spreadProps(__spreadValues({}, props), {
    letterSpacing: letterSpacing(props.fontSize)
  });
};
const fontWeightRegular = 400;
const fontWeightMedium = 500;
const fontWeightBold = 700;
const ncrMuiDefaultTypography = (theme) => {
  theme.typography = responsiveFontSizes(createTheme$1({
    typography: {
      fontFamily: [
        "Inter",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(","),
      h1: createMuiDefault({
        fontWeight: fontWeightBold,
        fontSize: 96,
        lineHeight: 1.167
      }),
      h2: createMuiDefault({
        fontWeight: fontWeightBold,
        fontSize: 60,
        lineHeight: 1.2
      }),
      h3: createMuiDefault({
        fontWeight: fontWeightBold,
        fontSize: 48,
        lineHeight: 1.167
      }),
      h4: createMuiDefault({
        fontWeight: fontWeightBold,
        fontSize: 34,
        lineHeight: 1.235
      }),
      h5: createMuiDefault({
        fontWeight: fontWeightBold,
        fontSize: 24,
        lineHeight: 1.334
      }),
      h6: createMuiDefault({
        fontWeight: fontWeightBold,
        fontSize: 20,
        lineHeight: 1.6
      }),
      subtitle1: createMuiDefault({
        fontWeight: fontWeightRegular,
        fontSize: 16,
        lineHeight: 1.75
      }),
      subtitle2: createMuiDefault({
        fontWeight: fontWeightMedium,
        fontSize: 14,
        lineHeight: 1.57
      }),
      body1: createMuiDefault({
        fontWeight: fontWeightRegular,
        fontSize: 16,
        lineHeight: 1.5
      }),
      body2: createMuiDefault({
        fontWeight: fontWeightRegular,
        fontSize: 14,
        lineHeight: 1.43
      }),
      button: createMuiDefault({
        fontWeight: fontWeightMedium,
        fontSize: 14,
        lineHeight: 1.75,
        textTransform: "none"
      }),
      caption: createMuiDefault({
        fontWeight: fontWeightRegular,
        fontSize: 12,
        lineHeight: 1.66
      }),
      overline: createMuiDefault({
        fontWeight: fontWeightRegular,
        fontSize: 12,
        lineHeight: 2.66,
        letterSpacing: 1
      })
    }
  })).typography;
};
function createDefaultPaletteOptions(theme = {}) {
  var _a, _b;
  const mode = (_b = (_a = theme == null ? void 0 : theme.palette) == null ? void 0 : _a.mode) != null ? _b : "light";
  theme.palette = __spreadValues({
    primary: mode === "dark" ? {
      lighter: "#C0E7FD",
      light: "#B7DBF7",
      main: "#64B5F5",
      dark: "#1B76D4",
      darker: "#2F597B",
      contrastText: "#000000"
    } : {
      lighter: "#DFECF9",
      light: "#64B5F5",
      main: "#1B76D4",
      dark: "#0048A6",
      darker: "#0B2F55",
      contrastText: "#FFFFFF"
    },
    secondary: mode === "dark" ? {
      lighter: "#FFFFFF",
      light: "#E0E0E0",
      main: "#B9B9B9",
      dark: "#979797",
      darker: "#616161",
      contrastText: "#000000"
    } : {
      lighter: "#EEEEEE",
      light: "#9E9E9E",
      main: "#757575",
      dark: "#616161",
      darker: "#000000",
      contrastText: "#FFFFFF"
    },
    info: mode === "dark" ? {
      lighter: "#D7DBFF",
      light: "#9FAAFE",
      main: "#7184FE",
      dark: "#4E6BFD",
      darker: "#495480",
      contrastText: "#000000"
    } : {
      lighter: "#E7E8FF",
      light: "#9EA3FE",
      main: "#5364FD",
      dark: "#062EC9",
      darker: "#212865",
      contrastText: "#FFFFFF"
    },
    success: mode === "dark" ? {
      lighter: "#B7DFB9",
      light: "#81C784",
      main: "#4CAF50",
      dark: "#388E3C",
      darker: "#265828",
      contrastText: "#000000"
    } : {
      lighter: "#EFF7EE",
      light: "#43A847",
      main: "#2D8630",
      dark: "#1B791F",
      darker: "#1E4620",
      contrastText: "#FFFFFF"
    },
    warning: mode === "dark" ? {
      lighter: "#FFD599",
      light: "#FFB74D",
      main: "#FF9800",
      dark: "#F57C00",
      darker: "#814D00",
      contrastText: "#000000"
    } : {
      lighter: "#FDF4E7",
      light: "#FFB547",
      main: "#FF9800",
      dark: "#C77700",
      darker: "#663D00",
      contrastText: "#000000"
    },
    error: mode === "dark" ? {
      lighter: "#FAB3AE",
      light: "#EF9A9A",
      main: "#FF5252",
      dark: "#D32F2F",
      darker: "#7B211B",
      contrastText: "#000000"
    } : {
      lighter: "#FDECEA",
      light: "#F44336",
      main: "#E91607",
      dark: "#C81002",
      darker: "#621B16",
      contrastText: "#FFFFFF"
    }
  }, theme.palette);
  return theme;
}
const addLighterAndDarker = (color2, mode, bgColor, textColor) => {
  const darkest = mode === "light" ? toHex(textColor.primary) : toHex(bgColor.default);
  const darker = setLuminance(color2.main, minLuminance(darkest, 1));
  const lightest = mode === "light" ? toHex(bgColor.default) : toHex(textColor.primary);
  const lighter = setLuminance(color2.main, maxLuminance(lightest, 1));
  return __spreadValues({ lighter, darker }, color2);
};
function makePalette(theme) {
  const _a = theme.palette, {
    background,
    text: text2,
    mode,
    primary,
    secondary,
    info,
    warning,
    success,
    error
  } = _a, rest = __objRest(_a, [
    "background",
    "text",
    "mode",
    "primary",
    "secondary",
    "info",
    "warning",
    "success",
    "error"
  ]);
  const paletteOutput = deepmerge({
    mode,
    background,
    text: text2,
    primary: addLighterAndDarker(primary, mode, background, text2),
    secondary: addLighterAndDarker(secondary, mode, background, text2),
    info: addLighterAndDarker(info, mode, background, text2),
    warning: addLighterAndDarker(warning, mode, background, text2),
    success: addLighterAndDarker(success, mode, background, text2),
    error: addLighterAndDarker(error, mode, background, text2)
  }, rest);
  theme.palette = paletteOutput;
}
const makeThemeComponents = (theme) => {
  const initialSpacing = theme.spacing;
  theme.spacing = createTheme$1({}).spacing;
  theme.components = {
    MuiAlert: MuiAlert(theme),
    MuiAppBar: MuiAppBar(),
    MuiButton: MuiButton(theme),
    MuiButtonBase: MuiButtonBase(theme),
    MuiButtonGroup: MuiButtonGroup(),
    MuiCheckbox: MuiCheckbox(theme),
    MuiChip: MuiChip(theme),
    MuiDataGrid: MuiDataGrid(),
    MuiCard: MuiCard(),
    MuiFilledInput: MuiFilledInput(theme),
    MuiIconButton: MuiIconButton(),
    MuiInputLabel: MuiInputLabel(),
    MuiLinearProgress: MuiLinearProgress(theme),
    MuiPaper: MuiPaper(),
    MuiRadio: MuiRadio(theme),
    MuiSlider: MuiSlider(theme),
    MuiSwitch: MuiSwitch(theme),
    MuiTextField: MuiTextField(),
    MuiFormHelperText: MuiFormHelperText()
  };
  theme.spacing = initialSpacing;
};
function makeDefaultTheme(theme, makeComponents = true) {
  makePalette(theme);
  ncrMuiDefaultTypography(theme);
  theme.mixins = __spreadProps(__spreadValues({}, theme.mixins), {
    _ncr_internal: makeInternalMixins(theme)
  });
  if (makeComponents)
    makeThemeComponents(theme);
  return theme;
}
function createDefaultSpacingOptions(theme = {}) {
  if (!theme.shape) {
    theme.shape = {
      borderRadius: 8
    };
  }
  return theme;
}
const createThemeBase = (themeOptions, isTest = false) => {
  createDefaultSpacingOptions(themeOptions);
  createDefaultPaletteOptions(themeOptions);
  return makeDefaultTheme(createTheme$1(themeOptions), !isTest);
};
const createTheme = (themeOptions = {}) => createThemeBase(themeOptions);
function makeStyles(styleFn) {
  return () => {
    const theme = useTheme$3();
    const styles = useMemo(() => styleFn(theme), [theme, styleFn]);
    return styles;
  };
}
const createHeadingLineHeight = (fontSize2, {
  gridSize = 4
} = { gridSize: 4 }) => {
  let grids = fontSize2 * 1.33 / gridSize;
  if (grids * gridSize < fontSize2 * 1.2) {
    grids += 1;
  }
  return Number((grids * gridSize / fontSize2).toFixed(3));
};
const getKeys = (obj) => Object.keys(obj);
const updateThemeFontScale = (modularScaleConfig, theme, opts = {}) => {
  var _a, _b, _c, _d;
  const options = Object.assign({
    adjustLetterSpacing: true
  }, opts);
  if (typeof modularScaleConfig === "object") {
    const originalFontScale = modularScaleConfig;
    modularScaleConfig = {
      xs: originalFontScale.xs
    };
    modularScaleConfig.sm = (_a = originalFontScale.sm) != null ? _a : modularScaleConfig.xs;
    modularScaleConfig.md = (_b = originalFontScale.md) != null ? _b : modularScaleConfig.sm;
    modularScaleConfig.lg = (_c = originalFontScale.lg) != null ? _c : modularScaleConfig.md;
    modularScaleConfig.xl = (_d = originalFontScale.xl) != null ? _d : modularScaleConfig.lg;
  } else {
    modularScaleConfig = {
      xs: modularScaleConfig,
      sm: modularScaleConfig,
      md: modularScaleConfig,
      lg: modularScaleConfig,
      xl: modularScaleConfig
    };
  }
  const config = modularScaleConfig;
  const makeScaleItem = (position2, scale) => {
    const scaleBase = theme.typography.fontSize + 2;
    const fontSize2 = Math.round(scaleBase * config[scale] ** position2);
    const lineHeight2 = createHeadingLineHeight(fontSize2);
    const res = {
      fontSize: theme.typography.pxToRem(fontSize2),
      lineHeight: lineHeight2
    };
    if (position2 === 0) {
      res.fontSize = theme.typography.pxToRem(scaleBase);
      res.lineHeight = createHeadingLineHeight(scaleBase);
    }
    if (options.adjustLetterSpacing) {
      if (position2 === 0) {
        res.letterSpacing = letterSpacing(scaleBase);
      } else {
        res.letterSpacing = letterSpacing(fontSize2);
      }
    }
    return res;
  };
  const scaledSizes = Object.fromEntries(getKeys(config).map((fontScaleKey) => {
    return [
      fontScaleKey,
      {
        h1: makeScaleItem(5, fontScaleKey),
        h2: makeScaleItem(4, fontScaleKey),
        h3: makeScaleItem(3, fontScaleKey),
        h4: makeScaleItem(2, fontScaleKey),
        h5: makeScaleItem(1, fontScaleKey),
        h6: makeScaleItem(0, fontScaleKey)
      }
    ];
  }));
  getKeys(scaledSizes.xs).forEach((headingType) => {
    var _a2;
    theme.typography[headingType] = __spreadProps(__spreadValues(__spreadValues({}, (_a2 = theme.typography[headingType]) != null ? _a2 : {}), scaledSizes["xs"][headingType]), {
      [theme.breakpoints.up("sm")]: __spreadValues({}, scaledSizes["sm"][headingType]),
      [theme.breakpoints.up("md")]: __spreadValues({}, scaledSizes["md"][headingType]),
      [theme.breakpoints.up("lg")]: __spreadValues({}, scaledSizes["lg"][headingType]),
      [theme.breakpoints.up("xl")]: __spreadValues({}, scaledSizes["xl"][headingType])
    });
  });
  return theme;
};
const responsiveThemeFontSizes = (modularScaleConfig, theme, {
  adjustLetterSpacing = true
} = {
  adjustLetterSpacing: true
}) => {
  var _a, _b, _c, _d;
  const originalFontScale = modularScaleConfig;
  modularScaleConfig = {
    xs: originalFontScale.xs
  };
  modularScaleConfig.sm = (_a = originalFontScale.sm) != null ? _a : modularScaleConfig.xs;
  modularScaleConfig.md = (_b = originalFontScale.md) != null ? _b : modularScaleConfig.sm;
  modularScaleConfig.lg = (_c = originalFontScale.lg) != null ? _c : modularScaleConfig.md;
  modularScaleConfig.xl = (_d = originalFontScale.xl) != null ? _d : modularScaleConfig.lg;
  const config = modularScaleConfig;
  const makeScaleItem = (scale) => {
    const sizeNames = [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6"
    ];
    const res = sizeNames.map((key) => [
      key,
      __spreadValues({
        fontSize: theme.typography.pxToRem(config[scale][key]),
        lineHeight: createHeadingLineHeight(config[scale][key])
      }, adjustLetterSpacing ? {
        letterSpacing: letterSpacing(config[scale][key])
      } : {})
    ]);
    return Object.fromEntries(res);
  };
  const scaledSizes = Object.fromEntries(getKeys(config).map((fontScaleKey) => {
    return [fontScaleKey, makeScaleItem(fontScaleKey)];
  }));
  getKeys(scaledSizes.xs).forEach((headingType) => {
    var _a2;
    theme.typography[headingType] = __spreadProps(__spreadValues(__spreadValues({}, (_a2 = theme.typography[headingType]) != null ? _a2 : {}), scaledSizes["xs"][headingType]), {
      [theme.breakpoints.up("sm")]: __spreadValues({}, scaledSizes["sm"][headingType]),
      [theme.breakpoints.up("md")]: __spreadValues({}, scaledSizes["md"][headingType]),
      [theme.breakpoints.up("lg")]: __spreadValues({}, scaledSizes["lg"][headingType]),
      [theme.breakpoints.up("xl")]: __spreadValues({}, scaledSizes["xl"][headingType])
    });
  });
  return theme;
};
export { createTheme, createTheme as default, makeStyles, responsiveThemeFontSizes, updateThemeFontScale };
